var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EA4335;}\n\t.st1{fill:#34A853;}\n\t.st2{fill:#4A90E2;}\n\t.st3{fill:#FBBC05;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.2,208.3c19.9-60.3,76.5-103.6,143.7-103.6c36.1,0,68.6,12.8,94.3,33.7L430.5,64C385.2,24.4,327,0,261.8,0 C160.9,0,74,57.6,32.3,141.9L118.2,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348,384.3c-23.3,15-52.8,23-86.2,23c-66.9,0-123.3-43-143.4-102.9l-86.2,65.4C73.9,454.3,160.8,512,261.8,512 c62.6,0,122.4-22.2,167.1-64L348,384.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M428.9,448c46.8-43.7,77.2-108.7,77.2-192c0-15.1-2.3-31.4-5.8-46.5H261.8v98.9h137.3 c-6.8,33.3-25,59-51.1,75.9L428.9,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.4,304.4c-5.1-15.2-7.9-31.4-7.9-48.4c0-16.7,2.7-32.7,7.6-47.7l-85.9-66.4C15.1,176.2,5.8,214.9,5.8,256 c0,40.9,9.5,79.6,26.4,113.8L118.4,304.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8a4664ab3da2e08cac62af91483cbc3e.svg";
export { ForwardRef as ReactComponent };